import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { GetDashboardRole } from "../../../../../Components/Utils/roles";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../../Components/Utils/Buttons";


function ClientReportLayout() {
    const location = useLocation();
    let pathFile = location.pathname;
    const [value,setValue] = useState("")


    useEffect(()=>{
        if(pathFile === "/report/client-Management/client"){
            setValue("Client")
        }else if(pathFile === "/report/client-Management/survey-report"){
          setValue("Survey Report")
      }
      else if(pathFile === "/report/client-Management/contract"){
        setValue("Contract")
    }
    },[location])

  return (
    <div className=" w-full h-full  px-4 py-2 overflow-hidden">
      <div className=" w-full sm:flex justify-end sm:justify-between items-center">
      <Breadcrumb items={[
        {
          name: "Report",
          link: "/report",
        },
        {
            name: "Client-Management",
        },
        {
            name: value,
        }
      ]} />

      <div className="flex justify-end">
        <BackButton />
      </div>
      
      </div>

      {/* <div className="w-[100%] h-[calc(100vh-90px)] mt-3"> */}
        <div className="w-[100%] h-[calc(100vh-135px)] mt-2 bg-white rounded-lg px-3 pb-1">
            <Outlet/>
        {/* </div> */}
      </div>
    </div>
  );
}

export default ClientReportLayout;